import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

document.querySelectorAll('.swiper').forEach(swiper => {
    const section = swiper.closest('.swiper-section'); // 找到共同的父容器
    new Swiper(swiper, {
        pagination: {
            el: section.querySelector('.swiper-pagination'),
            clickable: true,
        },
        loop: true,
        speed:500,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
    });
});